import React, { useState } from "react";
import { useCart } from "../context/CartContext";
import { createOrder } from "../services/api";

const CartPage = () => {
  const { cart, removeFromCart, clearCart, total } = useCart();
  const [address, setAddress] = useState({ name: "", address: "", city: "", zip: "" });
  const [ordered, setOrdered] = useState(false);

  const handleOrder = async () => {
    const orderData = {
      items: cart.map((i) => ({ product: i._id, quantity: i.quantity, price: i.price })),
      totalAmount: total,
      shippingAddress: address,
    };
    await createOrder(orderData);
    clearCart();
    setOrdered(true);
  };

  if (ordered) return (
    <div style={{ textAlign: "center", padding: "100px 20px" }}>
      <div style={{ fontSize: "64px" }}>🎉</div>
      <h2 style={{ color: "#1a1a2e", fontSize: "2rem" }}>Order Placed Successfully!</h2>
      <p style={{ color: "#666" }}>Thank you for shopping with us.</p>
      <a href="/" style={{
        display: "inline-block", marginTop: "20px", padding: "12px 32px",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        color: "#fff", borderRadius: "10px", textDecoration: "none", fontWeight: "600"
      }}>Continue Shopping</a>
    </div>
  );

  return (
    <div style={{ padding: "40px 60px", background: "#f8f9fa", minHeight: "100vh" }}>
      <h1 style={{ fontSize: "2rem", color: "#1a1a2e", marginBottom: "32px" }}>🛒 Your Cart</h1>
      {cart.length === 0 ? (
        <div style={{ textAlign: "center", padding: "80px 20px" }}>
          <div style={{ fontSize: "64px" }}>🛒</div>
          <h2 style={{ color: "#1a1a2e" }}>Your cart is empty</h2>
          <a href="/" style={{
            display: "inline-block", marginTop: "16px", padding: "12px 32px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "#fff", borderRadius: "10px", textDecoration: "none", fontWeight: "600"
          }}>Shop Now</a>
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 380px", gap: "32px" }}>
          {/* Cart Items */}
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {cart.map((i) => (
              <div key={i._id} style={{
                background: "#fff", borderRadius: "16px", padding: "20px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                display: "flex", justifyContent: "space-between", alignItems: "center"
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                  <div style={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    borderRadius: "10px", width: "56px", height: "56px",
                    display: "flex", alignItems: "center", justifyContent: "center", fontSize: "24px"
                  }}>🖥️</div>
                  <div>
                    <p style={{ margin: 0, fontWeight: "600", color: "#1a1a2e" }}>{i.name}</p>
                    <p style={{ margin: 0, color: "#888", fontSize: "0.85rem" }}>Qty: {i.quantity}</p>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                  <span style={{ fontWeight: "700", fontSize: "1.1rem", color: "#1a1a2e" }}>
                    ₹{i.price * i.quantity}
                  </span>
                  <button onClick={() => removeFromCart(i._id)} style={{
                    background: "#fee2e2", border: "none", color: "#ef4444",
                    padding: "8px 14px", borderRadius: "8px", cursor: "pointer", fontWeight: "600"
                  }}>Remove</button>
                </div>
              </div>
            ))}
          </div>

          {/* Order Summary */}
          <div style={{
            background: "#fff", borderRadius: "16px", padding: "28px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.06)", height: "fit-content"
          }}>
            <h2 style={{ margin: "0 0 24px", color: "#1a1a2e" }}>Order Summary</h2>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
              <span style={{ color: "#666" }}>Subtotal</span>
              <span style={{ fontWeight: "600" }}>₹{total}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
              <span style={{ color: "#666" }}>Shipping</span>
              <span style={{ color: "#22c55e", fontWeight: "600" }}>FREE</span>
            </div>
            <div style={{
              borderTop: "1px solid #f0f0f0", paddingTop: "16px",
              display: "flex", justifyContent: "space-between", marginBottom: "24px"
            }}>
              <span style={{ fontWeight: "700", fontSize: "1.1rem" }}>Total</span>
              <span style={{ fontWeight: "700", fontSize: "1.1rem", color: "#667eea" }}>₹{total}</span>
            </div>

            <h3 style={{ margin: "0 0 16px", color: "#1a1a2e" }}>Shipping Address</h3>
            {["name", "address", "city", "zip"].map((field) => (
              <input
                key={field}
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                value={address[field]}
                onChange={(e) => setAddress({ ...address, [field]: e.target.value })}
                style={{
                  width: "100%", padding: "12px 16px", marginBottom: "12px",
                  borderRadius: "10px", border: "1px solid #e2e8f0",
                  fontSize: "0.95rem", boxSizing: "border-box", outline: "none"
                }}
              />
            ))}
            <button onClick={handleOrder} style={{
              width: "100%", padding: "14px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#fff", border: "none", borderRadius: "10px",
              fontWeight: "700", fontSize: "1rem", cursor: "pointer"
            }}>
              Place Order 🎉
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartPage;